<template>
  <div class="container page" style="background-color: #1f1c1f">
    <div class="header">
      <van-nav-bar :title="$t('my.online_service')" class="nav-bar">
        <template #left>
          <img
            src="/img/newLogin/download.png"
            @click="back()"
            style="width: 20px; height: 15px"
          />
        </template>
      </van-nav-bar>
    </div>
    <div class="servicelistItem">
      <div class="servicelistItemTop">
        <img class="servicelistItemImage" src="img/mine/kefu.png" />
        <div class="servicelistItemText">
          {{
            this.$store.getters.getBaseInfo.name !== undefined
              ? this.$store.getters.getBaseInfo.name
              : this.$t("my.title")
          }}
        </div>
        <div class="servicelistItemBtn" @click="toServicePage()">
          <div class="servicelistItemBtnText">
            {{ $t("my.contact") }}
          </div>
        </div>
      </div>
      <div class="servicelistItemBottom">
        <div class="servicelistItemInfoText">
          {{ $t("my.service_time") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    back() {
      return window.history.back();
    },
    toServicePage() {
      const service = this.$store.getters.getBaseInfo;
      console.log(service);
      if (service.iskefu == 1) {
        console.log("ssss");
        window.location.href = service.kefu;
      }
      // this.$router.push("ServicePage");
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.servicelistItem {
  display: flex;
  flex-direction: column;
  height: 200px;
  padding: 30px 30px;
  margin: 30px 20px;
  border-radius: 20px;
  justify-content: space-between;
  background: linear-gradient(120deg, #212121, #313131);
}
.servicelistItem .servicelistItemTop {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100px;
}
.servicelistItem .servicelistItemTop .servicelistItemImage {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.servicelistItem .servicelistItemTop .servicelistItemText {
  margin-left: 50px;
  font-size: 43px;
  font-weight: 700;
  color: #e6b98a;
  flex: 1;
}
.servicelistItem .servicelistItemTop .servicelistItemBtn {
  display: flex;
  width: 150px;
  height: 55px;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #efcba7, #dcab76);
}
.servicelistItem
  .servicelistItemTop
  .servicelistItemBtn
  .servicelistItemBtnText {
  color: #fff;
  font-size: 25px;
}
.servicelistItem .servicelistItemBottom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #ccc;
  margin-top: 20px;
}
.servicelistItem .servicelistItemBottom .servicelistItemInfoText {
  font-size: 30px;
}

@media screen and (min-width: 1024px) {
  .container {
    width: 430px;
    top: 0 !important;
    margin: 0 auto;
    height: 100vh;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(255, 255, 255, 0.05);
  }
  .nav-bar {
    height: 50px;
  }

  .servicelistItem {
    height: 140px;
    padding: 10px;
    margin: 15px 20px;
    border-radius: 15px;
  }

  .servicelistItem .servicelistItemBottom .servicelistItemInfoText {
    font-size: 14px;
  }

  .servicelistItem .servicelistItemTop .servicelistItemText {
    font-size: 18px;
    margin-left: 60px;
  }

  .servicelistItem .servicelistItemTop .servicelistItemBtn {
    width: 60px;
    height: 30px;
  }

  .servicelistItem
    .servicelistItemTop
    .servicelistItemBtn
    .servicelistItemBtnText {
    font-size: 14px;
  }

  .servicelistItem .servicelistItemTop .servicelistItemImage {
    width: 50px;
    height: 50px;
  }

  .servicelistItem .servicelistItemBottom {
    padding: 5px;
    margin-top: 15px;
  }
}
</style>
